import React, { useEffect, useState } from "react";
import { Col, Form, Row, Typography, VertSelect } from "@vertem-core/vertice-ds";
import { notification } from "antd";
import axios from "axios";

const accountTypes = [
    { label: 'Conta Corrente', value: 1 },
    { label: 'Conta Poupança', value: 2 }
]

const formatBankCodeNumber = (bankCode) => {
    return bankCode ? String(bankCode).padStart(3, '0') : '000'
}

const filterOption = (input, option) => {
    return option.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(input.toLowerCase());
};

const BankData = ({ validationSchema, inputErrors, form, setBankFullName }) => {
    const [isLoadingBanks, setIsLoadingBanks] = useState(false)
    const [banks, setBanks] = useState([])

    const bankOptions = banks?.map((bank) => (
        {
            label: `${formatBankCodeNumber(bank.code)} - ${bank.fullName}`,
            value: bank.code
        }
    )).filter((bank) => bank.value)

    useEffect(() => {
        setIsLoadingBanks(true)
        axios.get('https://brasilapi.com.br/api/banks/v1').then((response) => {
            setBanks(response.data)
        }).catch((error) => {
            notification.error({
                message: 'Erro ao buscar bancos.',
                description: error.message
            })
        }).finally(() => {
            setIsLoadingBanks(false)
        })
    }, [])

    return (
        <Row gutter={[16, 16]}>
            <Col lg={12} md={12} sm={24} xs={24}>
                <Form.Item rules={validationSchema} validateTrigger='onBlur' name='bank' required>
                    <VertSelect
                        loading={isLoadingBanks}
                        label="Banco"
                        placeholder="Procure banco por código ou nome"
                        disabled={isLoadingBanks}
                        options={bankOptions}
                        showSearch
                        filterOption={filterOption}
                        onChange={(bankSelected) => {
                            form.setFieldValue('bank', bankSelected)
                            setBankFullName(`${bankSelected} - ${banks.find((bank) => bank.code === bankSelected)?.name}`)
                        }}
                        status={(inputErrors.bank.hasError) ? 'error' : !form.isFieldTouched('bank') ? 'default' : 'success'}
                    />
                </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
                <Form.Item rules={validationSchema} validateTrigger='onBlur' name='accountType' required>
                    <VertSelect
                        label="Tipo de conta"
                        placeholder="Tipo de conta"
                        options={accountTypes}
                        status={(inputErrors.accountType.hasError) ? 'error' : !form.isFieldTouched('accountType') ? 'default' : 'success'}
                    />
                </Form.Item>
            </Col>
        </Row>
    )
}

export default BankData;